import { useSelector, useDispatch } from "react-redux";
import { Modal } from "@dds/components";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import { changeFax, changeIsFaxInvalid } from "../../../redux/Slices/FaxSlice";
import {
  changeFirstName,
  changeLastName,
  changeIsInValidFirstName,
  changeIsInValidLastName,
} from "../../../redux/Slices/NameSlice";
import { changeMobile } from "../../../redux/Slices/MobileSlice";
import {
  changeExtension,
  changeHomePhone,
  changeIsExtensionInValid,
  changeIsHomePhoneInValid,
  changeWorkPhone,
} from "../../../redux/Slices/PhoneSlice";
import {
  changeEmail,
  changeIsEmailValid,
} from "../../../redux/Slices/EmailSlice";
import {
  changeCompanyName,
  changeCountryCode,
  changeSelectedState,
  changeCountryName,
  changeStreetAddress,
  changeAddLine2,
  changeAddLine3,
  changeAddLine4,
  changeAddLine5,
  changeCity,
  changeZipCode,
  changeIsStreetValid,
  changeIsCityValid,
  changeIsSelectedStateValid,
  changeIsZipCodeInValid,
} from "../../../redux/Slices/PostMailSlice";
import { changeIsMobileInvalid } from "../../../redux/Slices/MobileSlice";
import { changeIsSMSInvalid, changeSMS } from "../../../redux/Slices/SMSSlice";
import {
  changeIsWhatsAppInvalid,
  changeWhatsApp,
  changeWhatsAppExt,
} from "../../../redux/Slices/WhatsAppSlice";
import { useEffect, useState } from "react";
import AddressModal from "../AddressModal/AddressModal";
import {
  glassboxErrorEvent,
  glassboxPopUpEvent,
  glassboxSuccessEvent,
} from "../../../core/components/Glassbox/Glassbox";

const Bottom = ({ cmsLabels, setListRemovalSuccess, traceToken }) => {
  const dispatch = useDispatch();
  const [verifiedAddress, setVerifiedAddress] = useState([]);
  const [showAVSLoader, setShowAVSLoader] = useState(false);
  const { country, language } = useSelector((state) => state.langSettings);
  const { email, isCheckedEmail } = useSelector((state) => state.email);
  const { isPostChecked, ...postMail } = useSelector((state) => state.postMail);
  const {
    homePhone,
    workPhone,
    extension,
    isCheckedExtension,
    isPhoneChecked,
  } = useSelector((state) => state.phone);
  const { mobile, isCheckedMobile } = useSelector((state) => state.mobile);
  const { sms, isCheckedSMS } = useSelector((state) => state.sms);
  const { whatsapp, whatsappExt, isCheckedWhatsApp, dropDownAPI } = useSelector(
    (state) => state.whatsapp
  );
  const { fax, isCheckedFax } = useSelector((state) => state.fax);
  const { firstName, lastName } = useSelector((state) => state.names);

  const [afterVerification, setAfterVerification] = useState(false);

  const [afterSubmit, setAfterSubmit] = useState(false);

  const [modal, setModal] = useState(null);

  useEffect(() => {
    const modalElem = document.querySelector("#postmodal");
    const modalAPI = Modal(modalElem);
    if (modalAPI) setModal(modalAPI);
  }, []);

  const searchParams = new URLSearchParams(
    window.location.search.toLowerCase()
  );
  const allowedSources = ["pcrp"];

  const resetFields = () => {
    dispatch(changeEmail(""));
    dispatch(changeIsEmailValid(null));
    dispatch(changeCompanyName(""));
    dispatch(changeCountryCode(""));
    dispatch(changeSelectedState(""));
    dispatch(changeCountryName(""));
    dispatch(changeStreetAddress(""));
    dispatch(changeAddLine2(""));
    dispatch(changeAddLine3(""));
    dispatch(changeAddLine4(""));
    dispatch(changeAddLine5(""));
    dispatch(changeCity(""));
    dispatch(changeZipCode(""));
    dispatch(changeIsStreetValid(null));
    dispatch(changeIsCityValid(null));
    dispatch(changeIsSelectedStateValid(null));
    dispatch(changeIsZipCodeInValid(null));
    dispatch(changeHomePhone(""));
    dispatch(changeWorkPhone(""));
    dispatch(changeExtension(""));
    dispatch(changeMobile(""));
    dispatch(changeSMS(""));
    dispatch(changeWhatsApp(""));
    dispatch(changeIsWhatsAppInvalid(null));
    dispatch(changeWhatsAppExt(""));
    dispatch(changeFax(""));
    dispatch(changeFirstName(""));
    dispatch(changeLastName(""));
    dispatch(changeIsInValidFirstName(null));
    dispatch(changeIsInValidLastName(null));
    setAfterVerification(false);
    setListRemovalSuccess(null);
    setAfterSubmit(false);
    dropDownAPI?.clearSelection();
  };

  const validateAllForErrors = () => {
    //Change the regex
    const regExEmail = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
    const regExUSZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

    let error = false;

    if (isCheckedEmail) {
      if (regExEmail.test(email.toLowerCase())) {
        dispatch(changeIsEmailValid(false));
      } else {
        dispatch(changeIsEmailValid(true));
        error = true;
        glassboxErrorEvent("invalid email");
      }
    }

    if (isPostChecked) {
      if (postMail?.streetAddress?.trim().length === 0) {
        dispatch(changeIsStreetValid(true));
        error = true;
        glassboxErrorEvent("invalid street address");
      } else {
        dispatch(changeIsStreetValid(false));
      }

      if (postMail.city.trim().length === 0) {
        dispatch(changeIsCityValid(true));
        error = true;
        glassboxErrorEvent("invalid city");
      } else {
        dispatch(changeIsCityValid(false));
      }

      if (postMail.selectedState.trim().length === 0) {
        dispatch(changeIsSelectedStateValid(true));
        error = true;
        glassboxErrorEvent("invalid state");
      } else {
        dispatch(changeIsSelectedStateValid(false));
      }

      if (postMail.zipCode.trim().length === 0) {
        dispatch(changeIsZipCodeInValid(true));
        error = true;
        glassboxErrorEvent("invalid zipcode");
      } else {
        dispatch(changeIsZipCodeInValid(false));
      }

      if (postMail.countryCode === "US") {
        if (regExUSZip.test(postMail.zipCode)) {
          dispatch(changeIsZipCodeInValid(false));
        } else {
          dispatch(changeIsZipCodeInValid(true));
          error = true;
          glassboxErrorEvent("invalid zipcode for US");
        }
      }
    }

    if (isPhoneChecked) {
      if (homePhone.trim().length === 0) {
        dispatch(changeIsHomePhoneInValid(true));
        error = true;
        glassboxErrorEvent("invalid home phone");
      } else {
        dispatch(changeIsHomePhoneInValid(false));
      }

      if (isCheckedExtension) {
        if (extension.trim().length === 0) {
          dispatch(changeIsExtensionInValid(true));
          glassboxErrorEvent("invalid extension");
        } else {
          dispatch(changeIsExtensionInValid(false));
        }
      }
    }

    if (isCheckedMobile) {
      if (mobile.trim().length === 0) {
        dispatch(changeIsMobileInvalid(true));
        error = true;
        glassboxErrorEvent("invalid mobile");
      } else {
        dispatch(changeIsMobileInvalid(false));
      }
    }
    if (isCheckedSMS) {
      if (sms.trim().length === 0) {
        dispatch(changeIsSMSInvalid(true));
        error = true;
        glassboxErrorEvent("invalid SMS");
      } else {
        dispatch(changeIsSMSInvalid(false));
      }
    }

    if (isCheckedWhatsApp) {
      if (
        whatsapp.trim().length === 0 ||
        whatsappExt === "" ||
        !/^\s*\d+(\s+\d+)*\s*$/.test(whatsapp)
      ) {
        dispatch(changeIsWhatsAppInvalid(true));
        error = true;
        glassboxErrorEvent("invalid WhatsApp");
      } else {
        dispatch(changeIsWhatsAppInvalid(false));
      }
    }

    if (isCheckedFax) {
      if (fax.trim().length === 0) {
        dispatch(changeIsFaxInvalid(true));
        error = true;
        glassboxErrorEvent("invalid fax");
      } else {
        dispatch(changeIsFaxInvalid(false));
      }
    }

    if (
      (isPostChecked ||
        isPhoneChecked ||
        isCheckedMobile ||
        isCheckedFax ||
        isCheckedSMS) &&
      firstName.trim().length === 0
    ) {
      dispatch(changeIsInValidFirstName(true));
      error = true;
      glassboxErrorEvent(
        "invalid first name when post/phone/mobile/fax/sms/whatsapp"
      );
    } else {
      dispatch(changeIsInValidFirstName(false));
    }

    if (
      (isPostChecked ||
        isPhoneChecked ||
        isCheckedMobile ||
        isCheckedFax ||
        isCheckedSMS) &&
      lastName.trim().length === 0
    ) {
      dispatch(changeIsInValidLastName(true));
      error = true;
      glassboxErrorEvent(
        "invalid last name when post/phone/mobile/fax/sms/whatsapp"
      );
    } else {
      dispatch(changeIsInValidLastName(false));
    }

    return error;
  };

  const unsubscribe = async () => {
    if (validateAllForErrors() === true) {
      window.scrollTo({ top: 0 });
      return;
    }

    setAfterSubmit(true);

    let dataToUnsubscribe = {
      urlCC: country,
      urlLC: language,
      websourceId: 0,
      preferencearea: "",
      transactionGuid: "",
      fn: firstName.trim(),
      ln: lastName.trim(),
      email: email.trim(),
      pmcTraceId: traceToken
    };

    let addrLines = [postMail?.streetAddress?.trim() || ""];

    if (postMail?.addLine2 !== "")
      addrLines = [...addrLines, postMail?.addLine2?.trim()];
    if (postMail?.addLine3 !== "")
      addrLines = [...addrLines, postMail?.addLine3?.trim()];
    if (postMail?.addLine4 !== "")
      addrLines = [...addrLines, postMail?.addLine4?.trim()];
    if (postMail?.addLine5 !== "")
      addrLines = [...addrLines, postMail?.addLine5?.trim()];

    dataToUnsubscribe = {
      ...dataToUnsubscribe,
      postalMail: {
        coName: postMail?.companyName.trim(),
        addrLines,
        city: postMail?.city.trim(),
        state: postMail?.selectedState.trim(),
        postalCode: postMail?.zipCode.trim(),
        country: postMail?.countryCode.trim(),
        dbVal: "",
      },
    };

    let SourceCollected = "lr";

    const sourceParam = encodeURIComponent(searchParams.get("source"));

    if (sourceParam) {
      const foundItem = allowedSources.find((item) => item == sourceParam);

      if (foundItem) {
        SourceCollected = foundItem;
      }
    }

    dataToUnsubscribe = {
      ...dataToUnsubscribe,
      homephone: homePhone.trim(),
      workphone: workPhone.trim(),
      extension: extension.trim(),
      mobile: mobile.trim(),
      sms: sms.trim(),
        whatsappCountryCode: isCheckedWhatsApp ? whatsappExt.split("+")[1] || whatsappExt : "",
      whatsappAreaCode: "",
      whatsappNumber: isCheckedWhatsApp? whatsapp.trim(): "",
      fax: fax.trim(),
      SourceCollected,
    };

    try {
      const res = await fetch(process.env.REACT_APP_PMC_LIST_REMOVAL_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToUnsubscribe),
      });

      if (res.status === 200) {
        resetFields();
        setListRemovalSuccess(true);
        glassboxSuccessEvent("saved successfully");
      } else {
        setListRemovalSuccess(false);
        setAfterSubmit(false);
        glassboxErrorEvent("error, response status not 200");
      }
    } catch (error) {
      setListRemovalSuccess(false);
      glassboxErrorEvent(error);
    }
  };

  const fetchAVS = async () => {
    setVerifiedAddress([]);
    setShowAVSLoader(true);
    let addrLines = [postMail?.streetAddress.trim()];

    if (postMail?.addLine2 !== "")
      addrLines = [...addrLines, postMail?.addLine2.trim()];
    if (postMail?.addLine3 !== "")
      addrLines = [...addrLines, postMail?.addLine3.trim()];
    if (postMail?.addLine4 !== "")
      addrLines = [...addrLines, postMail?.addLine4.trim()];
    if (postMail?.addLine5 !== "")
      addrLines = [...addrLines, postMail?.addLine5.trim()];

    try {
      const res = await fetch(process.env.REACT_APP_PMC_MAIL_ADDRESS_URL, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Accept: "application/json",
          "X-PMC-TraceId": traceToken,
        },
        body: JSON.stringify({
          language: language,
          country: postMail.countryCode,
          address: {
            coName: postMail.companyName,
            addrLines: addrLines,
            city: postMail.city,
            state: postMail.selectedState,
            postalCode: postMail.zipCode,
            country: postMail.countryCode,
            dbVal: "",
          },
        }),
      });

      const data = await res.json();

      if (res.status == 200) {
        setVerifiedAddress(data?.datasource);
        setShowAVSLoader(false);
      } else {
        setShowAVSLoader(false);
        glassboxErrorEvent(error);
      }
    } catch (error) {
      setShowAVSLoader(false);
      glassboxErrorEvent(error);
      console.log(error);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    if (validateAllForErrors() === true) return;
    await fetchAVS();
    modal.open();
    glassboxPopUpEvent("Opened");
  };

  return (
    <div>
      <AddressModal
        verifiedAddress={verifiedAddress}
        showAVSLoader={showAVSLoader}
        cmsLabels={cmsLabels}
        postMail={postMail}
        modal={modal}
        setAfterVerification={setAfterVerification}
      />
      <div className="dds__py-2">
        {cmsParser(cms.Footer_Content, cmsLabels)
          .replace("{0}", cmsParser(cms.List_Removal_Days, cmsLabels))
          .replace("{1}", cmsParser(cms.List_Removal_Months, cmsLabels))}
      </div>
      <div className="dds__py-3">
        {cmsParser(cms.Privacy_Policy, cmsLabels)}{" "}
        <em>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.dell.com/${language}-${country}/lp/legal/policies-privacy`}
          >
            {cmsParser(cms.privacy_statement, cmsLabels)}
          </a>
        </em>
        .
      </div>
      <div className="dds__py-3">
        <button
          id="btnUnsubscribe"
          type="button"
          disabled={
            !(
              isCheckedEmail ||
              isPostChecked ||
              isPhoneChecked ||
              isCheckedMobile ||
              isCheckedFax ||
              isCheckedSMS ||
              isCheckedWhatsApp
            ) || afterSubmit
          }
          onClick={isPostChecked && !afterVerification ? verify : unsubscribe}
          className="dds__button dds__button--md dds__mr-2"
        >
          {cmsParser(cms.unsubscribe, cmsLabels)}
        </button>
        <button
          type="button"
          className="dds__button dds__button--md dds__button--secondary"
          onClick={resetFields}
        >
          {cmsParser(cms.Cancel, cmsLabels)}
        </button>
      </div>
    </div>
  );
};

export default Bottom;
